/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { compose } from 'ramda';
import ScrollLock from 'react-scrolllock';
import { Scrollbars } from 'react-custom-scrollbars';
import querystring from 'query-string';
import { connect } from 'react-redux';
import { updateUI as updateUIAction } from '../../stores/ui';
import LegacyLink from '../Common/LegacyLink';
import Logo from '../UI/Logo';
import LogoSmall from '../../../static/images/header_logo_small.svg';
import withAnalytics from '../Decorators/withAnalytics';
import PrimaryNav from './HeaderPartials/PrimaryNav';
import SecondaryNav from './HeaderPartials/SecondaryNav';
import TertiaryNav from './HeaderPartials/TertiaryNav';
import FindParkingCTA from './HeaderPartials/FindParkingCTA';
import Brand from '../UI/Brand';
import SuperUserBar from './SuperUserBar';

import '../../../static/scss/components/header.scss';

const buildNavigation = (
  showSearchLink,
  isStatic,
  secondaryClass,
  isAdmin,
  user,
  renderPrimaryLinks
) => (
  <>
    <PrimaryNav
      showSearchLink={showSearchLink}
      isStatic={isStatic}
      renderPrimaryLinks={renderPrimaryLinks}
    />
    <SecondaryNav
      secondaryClass={secondaryClass}
      isAdmin={isAdmin}
      user={user}
      isStatic={isStatic}
    />
  </>
);

const conditionallyRenderTertiaryNav = location => {
  const tertiaryDisabled = ['rent-your-space'];

  if (location && location.search) {
    const { showTertiaryNavigation, page } = querystring.parse(location.search);
    if (
      !!parseInt(showTertiaryNavigation, 10) &&
      !tertiaryDisabled.includes(page)
    ) {
      return (
        <div className="c-header__row">
          <TertiaryNav location={location} />
        </div>
      );
    }
  }
  return null;
};

export class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mobileVisible: false,
      secondaryVisible: false
    };
  }

  componentWillReceiveProps(nextProps) {
    // When the route changes hide the side menu
    if (this.props.location.pathname !== nextProps.location.pathname) {
      this.setState({ mobileVisible: false });
    }
  }

  toggleMobileMenu() {
    const { mobileVisible } = this.state;
    this.setState({ mobileVisible: !mobileVisible });
  }

  toggleSecondary(e) {
    if (window && window.innerWidth >= 860) {
      const { secondaryVisible } = this.state;
      e.preventDefault();
      this.setState({ secondaryVisible: !secondaryVisible });
    }
  }

  render() {
    const headerClass = 'c-header';

    const {
      user,
      location,
      isStatic,
      updateUI,
      analytics,
      ui: uiState,
      theme,
      mobileHeader
    } = this.props;

    const { mobileVisible, secondaryVisible } = this.state;

    const isAdmin = !!(user && user.isAdmin);
    const menuContainerClass = mobileVisible
      ? `${headerClass}__menu-container--visible`
      : '';
    const secondaryClass = `${headerClass}__menu${
      secondaryVisible ? ` ${headerClass}__menu--visible` : ''
    }`;
    const userMenuClass = this.props.user
      ? ''
      : ' c-header__menu--user-no-auth';

    const {
      checkout,
      searchResults,
      hidePrimaryNav,
      minimalBackground,
      darkMobileMenu
    } = theme;
    const checkoutClass = checkout ? '--checkout' : '';
    const searchResultsClass = searchResults ? '--searchResults' : '';
    const headerBackground = searchResults && !mobileHeader ? 'dark' : 'light';
    const darkMobileMenuClass = darkMobileMenu
      ? `${headerClass}--darkMobileMenu`
      : '';

    const renderPrimaryLinks =
      hidePrimaryNav || Boolean(checkout) || Boolean(searchResults);

    const tertiaryNavigation = conditionallyRenderTertiaryNav(location);
    const showSearchLink = !!tertiaryNavigation;
    const mainNavigation = buildNavigation(
      showSearchLink,
      isStatic,
      secondaryClass,
      isAdmin,
      user,
      renderPrimaryLinks
    );

    return (
      <header
        className={`${headerClass} ${
          minimalBackground ? `${headerClass}--background-minimal` : ''
        } ${
          tertiaryNavigation ? `${headerClass}--has-tertiary` : ''
        } ${headerClass}${checkoutClass} ${headerClass}${searchResultsClass} ${darkMobileMenuClass}`}
      >
        {mobileVisible && <ScrollLock />}
        <div className="c-header__row">
          <div className={`c-header__logo c-header__logo${checkoutClass}`}>
            <span className="c-header__logo-container">
              <Logo theme={headerBackground} />
            </span>
            {checkout && (
              <div className="c-header__logo--secure">
                <p>Secure Payment</p>
              </div>
            )}
          </div>
          <Brand wrap color>
            <div
              className={`c-header__mobile-anchor c-header__mobile-anchor${checkoutClass}`}
              onClick={this.toggleMobileMenu.bind(this)}
            />
          </Brand>
          <FindParkingCTA
            updateUI={updateUI}
            analytics={analytics}
            headerShouldShowCTA={uiState.headerShouldShowCTA}
          />
          <div className={`c-header__menu-container ${menuContainerClass}`}>
            {mobileVisible && (
              <div className="c-header__logo-small">
                <img src={LogoSmall} alt="JustPark" />
              </div>
            )}
            <div className="c-header__mobile-scroll">
              {(() => {
                if (__CLIENT__ && window.innerWidth < 780) {
                  return (
                    <Scrollbars autoHeight autoHeightMax={350}>
                      {mainNavigation}
                    </Scrollbars>
                  );
                }
                return <div>{mainNavigation}</div>;
              })()}
            </div>
            <ul
              className={`c-header__menu c-header__menu--user${userMenuClass}`}
            >
              <li>
                {user && (
                  <Brand color>
                    <LegacyLink
                      to="dashboard/"
                      onClick={this.toggleSecondary.bind(this)}
                    >
                      {user.unreadMessages > 0 && (
                        <div className="c-header__menu--message-count">
                          {user.unreadMessages}
                        </div>
                      )}
                      {`${user.firstName} ${user.lastName &&
                        user.lastName.charAt(0).toUpperCase()}`}

                      <Brand>
                        <div
                          className={`c-header__menu--user__dropdown c-header__menu--user__dropdown${checkoutClass}`}
                        />
                      </Brand>
                    </LegacyLink>
                  </Brand>
                )}
                {!user && (
                  <Brand color>
                    <Link
                      onClick={() =>
                        analytics.track('click:nav:login', {
                          page: window.location.pathname.toLowerCase()
                        })
                      }
                      to="/auth/login"
                      className="c-header__menu--login-link"
                    >
                      Login
                    </Link>
                  </Brand>
                )}
              </li>
              {!user && [
                <li key="registration">
                  <Brand color borderColor>
                    <LegacyLink
                      to="registration"
                      className="c-header__menu--login-link"
                    >
                      Sign Up
                    </LegacyLink>
                  </Brand>
                </li>
              ]}
            </ul>
          </div>
          {mobileVisible && (
            <div
              className="c-header__menu-overlay c-header__menu-overlay--visible"
              onClick={this.toggleMobileMenu.bind(this)}
            />
          )}
        </div>
        {tertiaryNavigation}
        <SuperUserBar user={user} />
      </header>
    );
  }
}

Header.defaultProps = {
  user: false,
  ui: {},
  isStatic: false,
  mobileHeader: false
};

Header.propTypes = {
  user: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  ui: PropTypes.object,
  location: PropTypes.object,
  isStatic: PropTypes.bool,
  theme: PropTypes.object,
  mobileHeader: PropTypes.bool
};

Header.defaultProps = {
  user: undefined,
  ui: {},
  location: undefined,
  theme: {}
};

const mapStateToProps = state => ({
  ui: state.ui,
  mobileHeader: state.browser.lessThan.medium
});

const mapDispatchToProps = {
  updateUIAction
};

export default compose(
  withRouter,
  withAnalytics({}, {}),
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(Header);
